export type BundleType = "inspection-report-bundle" | "live-inspection-bundle";
export type PaymentMethod = "bundle" | "wallet" | "paystack";
export type InspectionStatus =
  "pending" | "scheduled" | "completed" | "cancelled";

import { Property } from "@/types/property";

export interface InspectionRequest {
  id: string;
  propertyTitle: string;
  propertyAddress: string;
  propertyImage: string;
  type: InspectionType;
  status: InspectionStatus;
  requestedDate: string;
  scheduledDate?: string;
  price: number;
  reportData?: InspectionReportData;
}

export interface InspectionReportData {
  overallScore: number; // e.g., 88/100
  inspectorName: string;
  inspectedAt: string;
  structuralRating: "Excellent" | "Good" | "Fair" | "Requires Attention";
  plumbingElectrical: "Verified" | "Issues Found";
  legalCheck: "Clear Title" | "Pending Review";
  summary: string;
  keyHighlights: string[];
}

export interface BundleBalance {
  inspectionReportBundle: number;
  liveInspectionReportBundle: number;
}

export interface GetUserBundleBalanceResponse {
  status: string;
  message: string;
  data: BundleBalance;
}

export interface UserInspectionProperty {
  id?: string;
  description?: string;
  address?: string;
  image_url?: string[];
  realtor?: {
    first_name?: string;
    last_name?: string;
  };
  created_at?: string;
}

export interface UserInspectionRequest {
  id?: string;
  property?: UserInspectionProperty;
  document_url?: string;
  report_body?: any;
  status?: string;
  created_at?: string;
}

export interface InspectionReportContent {
  report_body?: any;
  document_url?: string;
}

export interface UserLiveInspectionItem {
  id: string;
  contact_email: string;
  contact_phone_number: string;
  preferred_means_of_contact: "email" | "phone" | string;
  status: "requested" | "approved" | "rejected" | string;
  document_url: string | null;
  report_body: string | null;
  type: InspectionType;
  created_at: string;
  updated_at: string;
  property: Property;
}

export interface PaginationMetadata {
  totalCount: number;
  pageSize: number;
  currentPage: string;
  cursor: string;
  beforeCursor: string;
}

export interface GetUserLiveInspectionsData {
  results: UserLiveInspectionItem[];
  metadata: PaginationMetadata;
}

export interface GetUserLiveInspectionsResponse {
  status: string;
  message: string;
  data: GetUserLiveInspectionsData;
}

export enum InspectionType {
  LIVE_INSPECTION = "live_inspection",
  INSPECTION_REPORT = "inspection_report",
}
